import { Redirect, Switch, Route } from 'react-router-dom';
import React, { Suspense } from 'react';
import { Application, Loading } from '@fides/fides-react-components';
import { LogRouter } from './Log';
import { useGlobalConfigContext } from '../contexts/GlobalConfig';

const ClientsMigration = React.lazy(() => import('../../components/pages/AdministratorTools/ClientsMigration'));
const DataImport = React.lazy(() => import('../../components/pages/AdministratorTools/DataImport'));
const DowntimeNotifications = React.lazy(
  () => import('../../components/pages/AdministratorTools/DowntimeNotifications')
);
const DowntimeNotificationViewPage = React.lazy(
  () => import('../../components/pages/AdministratorTools/DowntimeNotifications/DowntimeNotificationViewPage')
);
const DowntimeNotificationEditor = React.lazy(
  () => import('../../components/pages/AdministratorTools/DowntimeNotifications/DowntimeNotificationEditor')
);
const FileUpload = React.lazy(() => import('../../components/pages/AdministratorTools/FileUpload'));

export const AdministratorToolsRouter = () => {
  const { accessHelper } = useGlobalConfigContext();

  const isAdminImpersonated =
    accessHelper.isFidesAdministrator(Application.EFTWEB) && accessHelper.isImpersonatedAsClient;
  const isFidesAdmin =
    !accessHelper.isImpersonated &&
    (accessHelper.isFidesAdministrator(Application.EFTWEB) ||
      accessHelper.isFidesReadOnlyAdministrator(Application.EFTWEB));

  const administratorToolsSubPath = isFidesAdmin ? 'downtime-notifications' : 'clients-migration';

  return (
    <Switch>
      <Route path='/administrator-tools/clients-migration' exact>
        <Suspense fallback={<Loading />}>
          {isAdminImpersonated ? <ClientsMigration /> : <Redirect to='/page-not-found' />}
        </Suspense>
      </Route>
      <Route path='/administrator-tools/data-import' exact>
        <Suspense fallback={<Loading />}>
          <Suspense fallback={<Loading />}>
            {isAdminImpersonated ? <DataImport /> : <Redirect to='/page-not-found' />}
          </Suspense>
        </Suspense>
      </Route>
      <Route path='/administrator-tools/downtime-notifications' exact>
        <Suspense fallback={<Loading />}>
          {isFidesAdmin ? <DowntimeNotifications /> : <Redirect to='/page-not-found' />}
        </Suspense>
      </Route>
      <Route path='/administrator-tools/downtime-notifications/editor/:uniqueId?' exact>
        <Suspense fallback={<Loading />}>
          {isFidesAdmin ? <DowntimeNotificationEditor /> : <Redirect to='/page-not-found' />}
        </Suspense>
      </Route>
      <Route path='/administrator-tools/downtime-notifications/:uniqueId' exact>
        <Suspense fallback={<Loading />}>
          {isFidesAdmin ? <DowntimeNotificationViewPage /> : <Redirect to='/page-not-found' />}
        </Suspense>
      </Route>
      <Route path='/administrator-tools/file-upload' exact>
        <Suspense fallback={<Loading />}>{isFidesAdmin ? <FileUpload /> : <Redirect to='/page-not-found' />}</Suspense>
      </Route>
      <Route path='/log'>
        <LogRouter />
      </Route>
      <Redirect from='/administrator-tools/' to={`/administrator-tools/${administratorToolsSubPath}`} exact />
    </Switch>
  );
};
